import { render, staticRenderFns } from "./TreatmentDropdown.vue?vue&type=template&id=05679176&scoped=true"
import script from "./TreatmentDropdown.vue?vue&type=script&lang=js"
export * from "./TreatmentDropdown.vue?vue&type=script&lang=js"
import style0 from "./TreatmentDropdown.vue?vue&type=style&index=0&id=05679176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05679176",
  null
  
)

export default component.exports